export enum typeFormRequestEnum {
    IPTU = 1,
    ITBI = 2,
    SEAD = 3,
    INSCRICAO = 4,
    DEFAULT = 5,
    ALVARA = 6,
    SEMURB = 7
} 
